import { render, staticRenderFns } from "./ShipmentCustomFieldModal.vue?vue&type=template&id=7e459b0f&"
import script from "./ShipmentCustomFieldModal.vue?vue&type=script&lang=js&"
export * from "./ShipmentCustomFieldModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e459b0f')) {
      api.createRecord('7e459b0f', component.options)
    } else {
      api.reload('7e459b0f', component.options)
    }
    module.hot.accept("./ShipmentCustomFieldModal.vue?vue&type=template&id=7e459b0f&", function () {
      api.rerender('7e459b0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/BookingFields/components/ShipmentCustomFieldModal.vue"
export default component.exports